<template>
  <v-row>
    <v-col
      cols="12"
      md="12"
    >
      <v-card
        outlined
        elevation="0"
        class="mx-auto portals-filter"
      >
        <v-card-text class="portals-filter__content">
          <div class="portals-filter__top">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="indigo">mdi-filter-variant</v-icon>
              <span class="portals-filter__title">Filters</span>
            </div>

            <div class="portals-filter__actions">
              <v-btn
                small
                color="indigo"
                dark
                class="mr-2"
                @click="handleSearch()"
              >
                <v-icon left x-small>mdi-magnify</v-icon>
                Apply
              </v-btn>
              <v-btn
                small
                text
                @click="resetFilters()"
              >
                <v-icon left x-small>mdi-close</v-icon>
                Reset
              </v-btn>
            </div>
          </div>

          <v-row class="mt-2" dense>
            <v-col cols="12" md="4" lg="3">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Device ID"
                placeholder="Search device…"
                color="indigo"
                dense
                outlined
                clearable
                hide-details
                class="portals-filter__field"
                @keyup.enter="handleSearch()"
              />
            </v-col>

            <v-col cols="12" md="8" lg="5">
              <v-autocomplete
                v-model="selectedVenues"
                :items="venues"
                item-text="name"
                item-value="id"
                label="Venues"
                placeholder="Select venues…"
                multiple
                clearable
                dense
                outlined
                color="indigo"
                item-color="indigo"
                hide-details
                class="portals-filter__field"
                :menu-props="{ offsetY: true, maxHeight: 320 }"
              />
            </v-col>

            <v-col cols="12" md="6" lg="2">
              <v-select
                v-model="selectedType"
                :items="types"
                item-text="type"
                label="Type"
                placeholder="All"
                clearable
                dense
                outlined
                color="indigo"
                item-color="indigo"
                hide-details
                class="portals-filter__field"
              />
            </v-col>

            <v-col cols="12" md="6" lg="2">
              <v-select
                v-model="selectedRole"
                :items="roles"
                item-text="role"
                label="Role"
                placeholder="All"
                clearable
                dense
                outlined
                color="indigo"
                item-color="indigo"
                hide-details
                class="portals-filter__field"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  import { getfilterOptions } from '@/services/portals.js'
  export default {
    data () {
      return {
        search: '',
        venues: [],
        selectedVenues: [],
        selectedType: '',
        selectedRole: '',
        types: [],
        roles: [],
      }
    },
    mounted () {
      this.getFilters()
    },
    methods: {
      handleSearch () {
        const params = {
          device_id: this.search,
          venues: this.selectedVenues,
          portal_type: this.selectedType == null ? '' : this.selectedType,
          portal_role: this.selectedRole == null ? '' : this.selectedRole,
        }
        this.$emit('handleSearchChild', params)
      },
      resetFilters () {
        this.search = ''
        this.selectedVenues = []
        this.selectedType = ''
        this.selectedRole = ''
        const params = {
          device_id: this.search,
          venues: this.selectedVenues,
          portal_type: this.selectedType,
          portal_role: this.selectedRole,
        }
        this.$emit('handleSearchChild', params)
      },
      getFilters () {
        getfilterOptions().then((res) => {
          this.venues = res.data.obj.venues
          this.types = res.data.obj.types
          this.roles = res.data.obj.roles
        })
      },
    },
  }
</script>

<style scoped>
.portals-filter {
  border-color: rgba(15, 23, 42, 0.10) !important;
  border-radius: 14px !important;
  background: linear-gradient(180deg, rgba(63, 81, 181, 0.04) 0%, rgba(255, 255, 255, 1) 52%);
}
.portals-filter__title {
  font-weight: 800;
  color: rgba(15, 23, 42, 0.82);
  letter-spacing: 0.2px;
}

.portals-filter__content {
  padding-top: 14px !important;
}

.portals-filter__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.portals-filter__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.portals-filter__field :deep(.v-input__control) {
  border-radius: 10px;
}

@media (max-width: 600px) {
  .portals-filter__top {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
